import React, { useEffect } from "react";
import { CheckCircleIcon } from "staysure-component-library";

import ToggleBtnLabelWrapper from "@/app/shared-components/toggle-btn-wrapper/toggle-btn-label-wrapper";

import Styles from "./option-selection.module.css";
import { useCoverForContext } from "../../../provider/cover-for.provider";
import { OptionSelectionType } from "../../../types/cover-for.type";
import brandClassNames from "../../../utils/cover-for-classes.utils";

function OptionSelection({ options, onOptionSelect }: OptionSelectionType) {
  const { toggleBtnText } = brandClassNames;
  const {
    isFamilyModalOpen,
    toggleWrapperRef,
    shouldTriggerToggleWrapper,
    setShouldTriggerToggleWrapper,
  } = useCoverForContext();

  useEffect(() => {
    if (shouldTriggerToggleWrapper && toggleWrapperRef.current) {
      toggleWrapperRef.current.scrollIntoView({ behavior: "smooth" });
      setShouldTriggerToggleWrapper(false);
    }
  }, [
    shouldTriggerToggleWrapper,
    toggleWrapperRef,
    setShouldTriggerToggleWrapper,
  ]);

  return (
    <div
      className="flex flex-col gap-spacing-xs lg:w-[414px] md:w-[400px] w-full mt-spacing-l"
      ref={!isFamilyModalOpen ? toggleWrapperRef : null}
    >
      {options?.map(({ id, description, label, isSelected, isDisabled }) => (
        <ToggleBtnLabelWrapper
          data-testid={`party-type-buttons-group-${id}`}
          key={id}
          btnType="button"
          isToggleEnable={false}
          label={label}
          className={` active:bg-interactive-secondary-default active:text-dark-text-on-primary border-[1px]
                            bg-surface-neutral-option-1
                            border-interactive-secondary-default
                            text-text-on-primary w-full h-[56px] rounded-lg text-2xs text-left
                            font-body-font leading-[24px] 
                            py-spacing-s px-spacing-s hover:px-[11px] flex flex-col justify-center self-start"
                            gap-grid-system-space-050 ${Styles.policy_togglebtn_wrapper} ${Styles.toggle_btn} ${toggleBtnText}
                            hover:bg-interactive-action-hovered`}
          onClick={() => {
            onOptionSelect(id, label);
          }}
          description={description}
          isDefaultActive={isFamilyModalOpen ? id === "FAMILY" : isSelected}
          isActiveRightIcon
          activeRightIcon={<CheckCircleIcon />}
          isDisabled={isDisabled}
        />
      ))}
    </div>
  );
}

export default OptionSelection;
